import moment from 'moment';
import cloneDeep from 'bootstrap-vue/esm/utils/clone-deep';
import Activity from '../../lib/Activity';
import Workout from '../../lib/workout/Workout';

export const DATE_FORMAT = 'YYYY-MM-DD';

export const today = () => moment().endOf('day');
export const monday = () => moment().startOf('isoWeek');
export const lastMonday = () => moment().startOf('isoWeek').subtract(7, 'days');
export const oneWeekAgo = () => moment().subtract(6, 'days').startOf('day');
export const twoWeeksAgo = () => moment().subtract(13, 'days').startOf('day');

export const cloneReactiveObject = o => JSON.parse(JSON.stringify(o));

const fixDay = (d) => {
  const day = d;
  day.date = moment(day.date);
  if (day.activities) {
    day.activities = day.activities.map((a) => {
      const activity = a;
      activity.localStartTime = moment(a.localStartTime);
      return new Activity(activity);
    });
  }
  if (day.workouts) {
    day.workouts = day.workouts.map((t) => {
      const workout = t;
      workout.localStartTime = moment(t.localStartTime);
      return new Workout(workout);
    });
  }

  return day;
};

export const cloneCalendar = calendar => cloneReactiveObject(calendar).map(fixDay);
export const cloneCalendarDay = day => fixDay(cloneReactiveObject(day));

export const cloneDay = (d) => {
  const ret = Object.assign({}, d);
  Object.keys(ret).forEach((k) => {
    ret[k] = 0;
  });
  if ('activities' in ret) {
    delete ret.activities;
  }
  if ('workouts' in ret) {
    delete ret.workouts;
  }
  return ret;
};

export const fillGaps = (range, start, end) => {
  const ret = [];
  for (const m = start.clone().add(1, 'day'); m.isBefore(end); m.add(1, 'day')) {
    const d = range.find(i => i.date.isSame(m, 'day'));
    if (d) {
      ret.push(d);
    } else {
      const clone = cloneDay(range[0]);
      clone.date = m.clone().startOf('day');
      clone.plannedDistance = 0;
      clone.distance = 0;
      ret.push(clone);
    }
  }

  return ret.sort(
    (a, b) => moment(a.date).unix() - moment(b.date).unix(),
  );
};

export const calendarSort = (a, b) => moment(a.date)
  .unix() - moment(b.date).unix();

export const indexForDate = (date, calendar) => {
  if (!calendar) {
    return -1;
  }
  let min = 0;
  let max = calendar.length - 1;
  const loop = true;

  while (loop) {
    if (max < min) {
      break;
    }

    const mark = Math.round((min + max) / 2);
    if (calendar[mark].date.isSame(date, 'day')) {
      return mark;
    }

    if (calendar[mark].date.isBefore(date)) {
      min = mark + 1;
    } else {
      max = mark - 1;
    }
  }

  return -1;
};
